'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbTelefoon.$inject = ['TelefoonService'];


var _module = _angular2.default.module('cb.telefoon.cbTelefoon', []).directive('cbTelefoon', cbTelefoon);

exports.default = _module;


function cbTelefoon(TelefoonService) {
    return {
        restrict: 'A',
        scope: true,
        controller: cbTelefoonController,
        controllerAs: 'telefoon',
        link: function link(scope, element, attrs, cbTelefoonCtrl) {
            var product = attrs['cbTelefoon'].length > 0 ? attrs['cbTelefoon'] : undefined;

            TelefoonService.getOpenTime(product).then(function (response) {
                cbTelefoonCtrl.isOpenTekst = response.message;

                //Add class that displays red (closed) or green (open) dot in front of text
                if (response.type === 'nu') {
                    cbTelefoonCtrl.isOpen = true;
                } else {
                    cbTelefoonCtrl.isClosed = true;
                }
            });

            TelefoonService.getPhoneNumber(product).then(function (telefoonnummer) {
                cbTelefoonCtrl.telefoonnummer = telefoonnummer;
                cbTelefoonCtrl.telefoonnummerLink = 'tel:' + telefoonnummer.replace(/[()\s]/g, '').replace('055', '+3155').replace(' ', '');
            });
        }
    };
}

function cbTelefoonController() {}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/telefoon/cb-telefoon.directive.js
// module id = 824
// module chunks = 0